import { HeadCell } from '../../components/P4STable/types';
import { FieldInterface, SelectPosition } from '../../components/FieldTextInput/types';
import { FormDialogProps } from '../../components/FormDialog/types';
import UserRoles from '../../resources/enums/UserRoles';
import { TableSettings } from './types';
import AddButton from '../../components/Buttons/AddButton';
import EditButton from '../../components/Buttons/EditButton';
import ContactTypes from '../../resources/enums/ContactTypes';

const selectPositions = [
    {
        value: UserRoles.Admin,
        label: 'Admin',
    },
    {
        value: UserRoles.SuperAdmin,
        label: 'Super admin',
    },
    {
        value: `${UserRoles.Coach},${UserRoles.User}`,
        label: 'Coach',
    },
] as SelectPosition[];

const autocompletePosition = [
    { value: ContactTypes.Chat, label: 'Chat' },
    { value: ContactTypes.Meetings, label: 'Meetings' },
] as SelectPosition[];

const addTextFields = [
    {
        name: 'firstName',
        variant: 'outlined',
        required: true,
        type: 'text',
        id: 'firstName',
        label: 'First name',
        autoFocus: true,
    },
    {
        name: 'lastName',
        variant: 'outlined',
        required: true,
        type: 'text',
        id: 'lastName',
        label: 'Last name',
    },
    {
        name: 'email',
        variant: 'outlined',
        required: true,
        type: 'email',
        id: 'email',
        label: 'Email',
    },
    {
        data: selectPositions,
        defaultValue: UserRoles.Admin,
        id: 'role',
        label: 'Role',
        name: 'role',
        variant: 'outlined',
        required: true,
        type: 'select',
        select: true,
    },
] as FieldInterface[];

const editTextFields = [
    {
        data: selectPositions,
        defaultValue: UserRoles.SuperAdmin,
        id: 'role',
        label: 'Role',
        name: 'role',
        variant: 'outlined',
        required: true,
        type: 'select',
        select: true,
        autoFocus: true,
    },
];

export const columns = [
    {
        id: 'firstName',
        numeric: false,
        disablePadding: true,
        label: 'First name',
    },
    {
        id: 'lastName',
        numeric: true,
        disablePadding: false,
        label: 'Last name',
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'Email',
    },
    {
        id: 'role',
        numeric: true,
        disablePadding: false,
        label: 'Role',
    },
    {
        id: 'registrationDate',
        numeric: true,
        disablePadding: false,
        label: 'Registration date',
    },
] as HeadCell[];

export const tableSetting = {
    orderBy: 'role',
    filterBy: 'email',
    rowsPerPage: 10,
    pages: [10, 25, 50],
    orderDirection: 'desc',
} as TableSettings;

export const addParams = {
    buttonLabel: 'Add',
    button: AddButton,
    submitName: 'Add',
    title: 'Add new user',
    textFields: addTextFields,
    multipleOptions: autocompletePosition,
} as FormDialogProps;

export const editParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    submitName: 'Save',
    title: 'Edit user',
    textFields: editTextFields,
} as FormDialogProps;
